export enum EntityTyp {
  User = "User",
  Office = "Office",
  Employee = "Employee",
  Housing = "Housing",
  Client = "Client",
  Report = "Report",
}
